type FetchOptions = RequestInit & {
  requireAuth?: boolean;
};

export const fetchWithToken = async (
  url: string,
  options: FetchOptions = {}
) => {
  // Si requireAuth est true ou non spécifié, on vérifie le token et on redirige si nécessaire
  if (options.requireAuth !== false) {
    const token = localStorage.getItem("accessToken");
    // Si on n'a pas de token et qu'on n'est pas sur /login, rediriger
    if (!token && window.location.pathname !== "/login") {
      window.location.href = "/login";
      throw new Error("No access token found");
    }

    // Ajout du token dans les headers
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    };
  }

  // Faire la requête
  let response = await fetch(url, {
    ...options,
    credentials: "include",
  });

  // Vérifier si un nouveau token est présent dans les headers
  const newToken = response.headers.get("New-Access-Token");
  if (newToken) {
    localStorage.setItem("accessToken", newToken);
    // Si on avait un 401, on réessaie la requête avec le nouveau token
    if (response.status === 401) {
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${newToken}`,
      };
      response = await fetch(url, {
        ...options,
        credentials: "include",
      });
    }
  } else if (response.status === 401 && options.requireAuth !== false) {
    // Session expirée : on supprime le token et on redirige. Sur une route publique
    // (connexion, inscription…), un 401 est une réponse métier comme « identifiants
    // incorrects » : recharger /login effacerait le message d'erreur affiché.
    localStorage.removeItem("accessToken");
    window.location.href = "/login";
  }

  return response;
};
